'use strict';
import angular from 'angular';
import ngMaterial from 'angular-material';
import clinicalUpdatesAuthors from './clinical-updates/authors';
import clinicalUpdatesElements from './clinical-updates/elements';
import clinicalUpdates from './clinical-updates';
import askOurExperts from './ask-our-experts';
import clinicalPracticeTools from './clinical_practice_tools';
import { DrugDepletionsInteractions } from './drug-depletions-interactions/drug-depletions-interactions.module';
import resourcesByHealthCondition from './resources-by-health-condition';
import resourcesBySupplements from './resources-by-supplements';
import ClinicalResourcesController from './clinical-resources.controller';
import meetOurTeam from './ask-our-experts/meet-our-team';
import educationPartner from './education-partners';
import partners from './education-partners/partners';
import tapIntegrativePage from './education-partners/tap-integrative-page';
export default angular.module('eeComUiApp.clinicalResources', [ngMaterial, DrugDepletionsInteractions, resourcesBySupplements, resourcesByHealthCondition, askOurExperts, clinicalUpdates, clinicalPracticeTools, clinicalUpdatesAuthors, clinicalUpdatesElements, meetOurTeam, educationPartner, partners, tapIntegrativePage])
    .controller('ClinicalResourcesController', ClinicalResourcesController)
    .name;
//# sourceMappingURL=index.js.map